export default "__VITE_ASSET__bb64d3f6__"